module.exports = __webpack_public_path__ + "img/pharmacy_bottle-pill.1ca200cc.svg";